var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cls,style:(_vm.style)},[_c('div',{style:(_vm.middle)},[_vm._t("default",null,{"type":_vm.type}),(_vm.isCourse)?_vm._t("courseName",null,{"courseName":_vm.courseName}):_vm._e(),(_vm.isCourse)?_vm._t("className",null,{"className":_vm.className}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }